import * as React from 'react'

import { FormItem } from 'main/components/common/Form'
import { TextField } from 'main/ui'
import { IParams, IValidation } from './types'

interface IProps {
  params: IParams
  validation: IValidation
  onChange: (changes: Partial<IParams>) => void
}

export default function Fields(props: IProps) {
  const { params, validation, onChange } = props

  return (
    <FormItem label="Create a password">
      <TextField
        type="password"
        label="Password"
        placeholder="Create password"
        value={params.password}
        onChange={password => onChange({ password })}
        validationHint={validation.password}
        required
      />
    </FormItem>
  )
}
